/* eslint-disable prefer-const */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { Alert, Box, Button, Grid, Icon, IconButton, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { VTextField, VForm, useVForm, VTextFieldData, VFieldMoney, BasicSelect, AutoCompleteProdutor, AutoCompleteFazenda, AutoCompleteTransportadora, AutoCompleteVeiculos, AutoCompleteParceiro, IVFormErrors } from '../../../shared/forms';
import { FerramentasDeDetalheNfe } from '../../../shared/components';
import dayjs from 'dayjs';
import { LayoutBaseDePaginaNfe } from '../../../shared/layouts';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { AutoCompleteCfop } from '../../../shared/forms/AutoCompleteCfop';
import { NfeService } from '../../../shared/services/api/fiscal/nfe/NfeService';
import { DialoNfe } from './DialogNfe';
import { v4 as uuidv4 } from 'uuid';
import { Environment } from '../../../shared/environment';
import { DialoCancelar } from './DialogCancelar';
import { DialogCartaCorrecao } from './DialogCartaCorrecao';

interface IFormData {
  serie: number;
  nfe: number;
  indpag: number,
  dataemissao: Date;
  finnfe: number;
  nfecpl: string;
  tpag: string;
  cfop: number;
  obscomplementar: string;
  idprodutor: number;
  idparceiro: string;
  idtransportadora?: string | null;
  volumequantidade: string;
  volumemarca: string;
  volumepesoliquido: number;
  volumepesobruto: number;
  vprod: number;
  vbc: number;
  vicms: number;
  vfrete: number;
  vseg: number;
  vdesc: number;
  vipi: number;
  vpis: number;
  vconfins: number;
  vnfe: number;
  idfazenda: string;
  nferef: string;
  tpnfe: number;
  volesp: string;
  idveiculo?: string | null;
  modfrete: number;
  tpemis: number;
}

interface IItensNFe {
  iditens: string;
  idprod: string;
  descricao: string;
  un: string;
  ncm: string;
  cfop: number;
  cst: string;
  quantidade: number;
  preco: number;
  desconto: number;
  total: number;
  frete: number;
  seguro: number;
  bcicms: number;
  percentual: number;
  valoricms: number;
  bcst: number;
  percentualst: number;
  valoricmsst: number;
  cstipi: string;
  bcipi: number;
  percentualipi: number;
  valoripi: number;
  cstpis: string;
  bcpis: number;
  percentualpis: number;
  valorpis: number;
  cstcofins: string;
  bccofins: number;
  percentualcofins: number;
  valorcofins: number;
  voutros: number;
  bcicmsst: number;
  preducaoicms: number;
  modbc: string,
  modbcst: string,
  indtot: boolean,
}

interface IItensids {
  iditens: string;
}

const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  serie: yup.number().optional().default(1),
  nfe: yup.number().optional().default(0),
  tpemis: yup.number().required(),
  indpag: yup.number().required(),
  dataemissao: yup.date().required(),
  finnfe: yup.number().required(),
  nfecpl: yup.string().optional().default(''),
  tpag: yup.string().required(),
  cfop: yup.number().required(),
  obscomplementar: yup.string().optional().default(''),
  idprodutor: yup.number().required(),
  idparceiro: yup.string().required(),
  idtransportadora: yup.string().nullable(),
  volumequantidade: yup.string().required(),
  volumemarca: yup.string().optional().default(''),
  volumepesoliquido: yup.number().required(),
  volumepesobruto: yup.number().required(),
  vprod: yup.number().required(),
  vbc: yup.number().required(),
  vicms: yup.number().required(),
  vfrete: yup.number().required(),
  vseg: yup.number().required(),
  vdesc: yup.number().required(),
  vipi: yup.number().required(),
  vpis: yup.number().required(),
  vconfins: yup.number().required(),
  vnfe: yup.number().required(),
  idfazenda: yup.string().required(),
  nferef: yup.string().optional().default(''),
  tpnfe: yup.number().required(),
  modfrete: yup.number().required(),
  volesp: yup.string().optional().default(''),
  idveiculo: yup.string().nullable(),
});

export const DetalheDaNfe: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();

  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [opencancelar, setOpencancelar] = useState(false);
  const [opencarta, setOpencarta] = useState(false);
  const [statuss, setStatuss] = useState(1);
  const [value, setValue] = useState('');
  const [valueCancelar, setValueCancelar] = useState('');
  const [valueCarta, setValuecarta] = useState('');
  const [iditens, setIditens] = useState('');
  const [transportadora, setTransportadora] = useState('');
  const [cfop, setCfop] = useState('');
  const [pdf, setPdf] = useState('');
  const [protocolo, setProtocolo] = useState('');
  const [cancelar, setCancelar] = useState(1);
  const [rows, setRows] = useState<IItensNFe[]>([]);
  const [rowsids, setRowsids] = useState<IItensids[]>([]);
  const [dadositens, setDadositens] = useState<IItensNFe>();
  const guuid = uuidv4();
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirmItem, setOpenConfirmItem] = useState(false);
  const [iditem, setIditem] = useState('');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      navigate('/nfe');
    }
  };

  const handleDeleteItem = (idi: string) => {
    setOpenConfirmItem(true);
    setIditem(idi);
  };
  const handleConfirmDeleteItem = () => {
    let meuObjeto = { iditens: iditem };

    rowsids.push(meuObjeto);

    const indexToDelete = rows.findIndex((item) => item.iditens === iditem);
    if (indexToDelete !== -1) {
      const updatedList = [...rows];
      updatedList.splice(indexToDelete, 1);
      setRows(updatedList);

      const totais = calcularTotais(updatedList);
      const tvprod = totais.tvprod;
      const tbcicms = totais.tbcicms;
      const tvicms = totais.tvicms;
      const tconfins = totais.tconfins;
      const tpis = totais.tpis;
      const tipi = totais.tipi;
      const tfrete = totais.tfrete;
      const tseguro = totais.tseguro;
      const tdesconto = totais.tdesconto;
      const tnfe = totais.tvprod + totais.tfrete + totais.tseguro + totais.tipi + totais.tconfins + totais.toutros - totais.tdesconto;
      Object.entries(totais).forEach(([campo, valor]) => {
        formRef.current?.setFieldValue(campo, valor);
      });
      formRef.current?.setFieldValue('vnfe', tnfe);
      formRef.current?.setFieldValue('vprod', tvprod);
      formRef.current?.setFieldValue('vconfins', tconfins);
      formRef.current?.setFieldValue('vpis', tpis);
      formRef.current?.setFieldValue('vipi', tipi);
      formRef.current?.setFieldValue('vfrete', tfrete);
      formRef.current?.setFieldValue('vseg', tseguro);
      formRef.current?.setFieldValue('vdesc', tdesconto);
      formRef.current?.setFieldValue('vprod', tvprod);
      formRef.current?.setFieldValue('vicms', tvicms);
      formRef.current?.setFieldValue('vnfe', tnfe);
      formRef.current?.setFieldValue('vbc', tbcicms);
    }
    setOpenConfirmItem(false);
  };


  const handleCancelDeleteItem = () => {
    setOpenConfirmItem(false);
  };


  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      NfeService.getById(id)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            formRef.current?.setData(result);
            setPdf(Environment.URL_PDFNFE + result.pathpdf);
            setProtocolo(result.protocolo);
            setRows(result.itens);
            setCfop(result.cfop.toString());
            setStatuss(result.status);
            const dataObjeto = new Date(result.dataenvio);
            if (result.dataenvio !== null) {
              const diferencaEmDias = calcularDiferencaEntreDatas(dataObjeto, new Date());
              if (diferencaEmDias > 24) {
                setCancelar(1);
              } else {
                setCancelar(2);
              }
            }
          }
        });
    } else {
      formRef.current?.setData({
        tpnfe: 1,
        finnfe: '1',
        indpag: 0,
        tpag: '01',
        dataemissao: dayjs(),
        volesp: 'KG',
        obscomplementar: '',
        nferef: '',
        nfecpl: '',
        volumequantidade: 0,
        volumemarca: 'FORMOSA',
        volumepesoliquido: 0,
        volumepesobruto: 0,
        vprod: 0,
        vbc: 0,
        vicms: 0,
        vfcp: 0,
        vbcst: 0,
        vst: 0,
        vfcpst: 0,
        vfrete: 0,
        vseg: 0,
        vdesc: 0,
        vipi: 0,
        vipidevol: 0,
        vpis: 0,
        vconfins: 0,
        voutros: 0,
        vnfe: 0,
        modfrete: 9,
        tpemis: 1,
      });
    }
  }, [id]);

  function calcularDiferencaEntreDatas(data1: Date, data2: Date): number {
    const data1EmMilissegundos = data1.getTime();
    const data2EmMilissegundos = data2.getTime();
    const diferencaEmMilissegundos = Math.abs(data2EmMilissegundos - data1EmMilissegundos);
    const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60);
    return diferencaEmDias;
  }

  const handleSave = (dados: IFormData) => {
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        if (id === 'novo') {
          NfeService
            .create(dadosValidados, rows)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Lançamento Realizado com sucesso!');
                setOpenmsg(true);
              }
            });
        } else {
          NfeService
            .updateById(id, dadosValidados, rows, rowsids)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Alteração concluída com sucesso!');
                setOpenmsg(true);
              }
            });
        }
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const handleBuscarDados = (id: string) => {
    const updatedList = rows.map((listItem) => {
      if (listItem.iditens === id) {
        setDadositens(listItem);
      }
    });
  };

  const handleuuidtransportadora = (uuid: string | undefined) => {
    if (uuid != null) {
      setTransportadora(uuid);
    }
  };

  const handlecfop = (cfops: number | undefined) => {
    if (cfops != null) {
      if (cfops > 0) {
        setCfop(cfops.toString());
      }
    }
  };

  const handleClose = (newValue?: string) => {
    setOpen(false);

    if (newValue) {
      setValue(newValue);
    }
  };

  const handleClosecancelar = (newValue?: string) => {
    setOpencancelar(false);

    if (newValue) {
      setValueCancelar(newValue);
    }
  };

  const handleClosecarta = (newValue?: string) => {
    setOpencarta(false);

    if (newValue) {
      setValuecarta(newValue);
    }
  };

  type RowsType = IItensNFe[];

  const calcularTotais = (lista: RowsType) => {
    const tvprod = lista.reduce((acc, item) => acc + item.total, 0);
    const tbcicms = lista.reduce((acc, item) => acc + item.bcicms, 0);
    const tvicms = lista.reduce((acc, item) => acc + item.valoricms, 0);
    const tconfins = lista.reduce((acc, item) => acc + item.valorcofins, 0);
    const tpis = lista.reduce((acc, item) => acc + item.valorpis, 0);
    const tipi = lista.reduce((acc, item) => acc + item.valoripi, 0);
    const tfrete = lista.reduce((acc, item) => acc + item.frete, 0);
    const tseguro = lista.reduce((acc, item) => acc + item.seguro, 0);
    const tdesconto = lista.reduce((acc, item) => acc + item.desconto, 0);
    const toutros = lista.reduce((acc, item) => acc + item.voutros, 0);

    return {
      tvprod,
      tbcicms,
      tvicms,
      tconfins,
      tpis,
      tipi,
      tfrete,
      tseguro,
      tdesconto,
      toutros,
    };
  };

  const handleItens = (dados: IItensNFe) => {
    const index = rows.findIndex((listItem) => listItem.iditens === dados.iditens);

    let updatedList: RowsType;

    if (index !== -1) {
      updatedList = [...rows];
      updatedList[index] = dados;
    } else {
      updatedList = [...rows, dados];
    }
    setRows(updatedList);
    const totais = calcularTotais(updatedList);
    const tvprod = totais.tvprod;
    const tbcicms = totais.tbcicms;
    const tvicms = totais.tvicms;
    const tconfins = totais.tconfins;
    const tpis = totais.tpis;
    const tipi = totais.tipi;
    const tfrete = totais.tfrete;
    const tseguro = totais.tseguro;
    const tdesconto = totais.tdesconto;
    const tnfe = totais.tvprod + totais.tfrete + totais.tseguro + totais.tipi + totais.tconfins + totais.toutros + dados.valoricmsst - totais.tdesconto;
    Object.entries(totais).forEach(([campo, valor]) => {
      formRef.current?.setFieldValue(campo, valor);
    });

    formRef.current?.setFieldValue('vnfe', tnfe);
    formRef.current?.setFieldValue('vprod', tvprod);
    formRef.current?.setFieldValue('vconfins', tconfins);
    formRef.current?.setFieldValue('vpis', tpis);
    formRef.current?.setFieldValue('vipi', tipi);
    formRef.current?.setFieldValue('vfrete', tfrete);
    formRef.current?.setFieldValue('vseg', tseguro);
    formRef.current?.setFieldValue('vdesc', tdesconto);
    formRef.current?.setFieldValue('vprod', tvprod);
    formRef.current?.setFieldValue('vicms', tvicms);
    formRef.current?.setFieldValue('vnfe', tnfe);
    formRef.current?.setFieldValue('vbc', tbcicms);
  };

  const handlePrint = () => {
    setIsLoading(true);
    NfeService.Imprimir(id)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          const blob = new Blob([result], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => URL.revokeObjectURL(url), 10000);
        }
      });
  };

  const handleTransmitir = () => {
    setIsLoading(true);
    NfeService.transmitir(id)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          // window.open(Environment.URL_PDFNFE + result, '_blank');
          const blob = new Blob([result], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => URL.revokeObjectURL(url), 10000);
          // setTms('success');
          // setMsg('Transmitido Realizado com sucesso!');
          // setOpenmsg(true);
        }
      });
  };

  const handleAddProtocolo = () => {
    // setIsLoading(true);
    // NfeService.addprotocolo(id)
    //   .then((result) => {
    //     setIsLoading(false);
    //     if (result instanceof Error) {
    //       setTms('error');
    //       setMsg(result.message);
    //       setOpenmsg(true);
    //     } else {
    //       window.open(Environment.URL_PDFNFE + result, '_blank');
    //     }
    //   });
  };

  const handleCancelar = () => {
    setOpencancelar(true);
  };

  const handleCarta = () => {
    setOpencarta(true);
  };

  return (
    <LayoutBaseDePaginaNfe
      barraDeFerramentas={
        <FerramentasDeDetalheNfe
          textoBotaoNovo='Novo'
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoApagar={false}
          mostrarBotaoImpressao={id !== 'novo'}
          mostrarBotaoCancelar={id !== 'novo'}
          mostrarBotaoCarta={id !== 'novo'}
          mostrarBotaoProtocolo={id !== 'novo'}
          mostrarBotaoTransmitir={id !== 'novo'}
          mostrarBotaoApagarCarregando={false}
          mostrarBotaoImpressaoCarregando={isLoading}
          disableBotaoSalvar={statuss === 1 ? isLoading : true}
          disableBotaoImpressao={statuss === 2 ? isLoading : true}
          disableBotaoCancelar={cancelar === 2 ? isLoading : true}
          disableBotaoTransmitir={statuss === 1 ? isLoading : true}
          disableBotaoProtocolo={protocolo === null ? isLoading : true}
          disableBotaoSalvarEFechar={statuss === 1 ? isLoading : true}
          disableBotaoCarta={isLoading}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmTransmitir={handleTransmitir}
          aoClicarEmCancelar={handleCancelar}
          aoClicarEmCarta={handleCarta}
          aoClicarEmProtocolo={handleAddProtocolo}
          aoClicarEmVoltar={() => navigate('/nfe')}
          mostrarBotaoVoltarCarregando={isLoading}
          mostrarBotaoTransmitirCarregando={isLoading}
          aoClicarEmNovo={() => navigate('/nfe/detalhe/novo')}
          aoClicarEmImpressao={() => handlePrint()}
          mostrarBotaoNovoCarregando={isLoading}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave}>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {msg}
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirmItem} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="warning"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDeleteItem}>
                  Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDeleteItem}>
                  Nâo
                </Button>
              </>
            }
          >
            Tem certeza que deseja excluir este Item?
          </Alert>
        </Snackbar>
        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
          <Grid container direction="column" padding={1} spacing={1}>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}
            <Grid container item direction="row" spacing={2}>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={2} >
                  <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                    <AutoCompleteParceiro
                      isExternalLoading={statuss === 1 ? isLoading : true}
                      cfops={handlecfop}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <AutoCompleteProdutor
                      isExternalLoading={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                    <AutoCompleteFazenda
                      isExternalLoading={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                    <VTextFieldData
                      fullWidth
                      name='dataemissao'
                      label='Data Emissão'
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={2} >
                  <Grid item xs={12} sm={12} md={2} lg={1} xl={2}>
                    <BasicSelect
                      name='tpemis'
                      label='Tipo Emissão'
                      data={[
                        { nameBD: '1', descricao: 'Emissão normal' },
                        { nameBD: '2', descricao: 'Contingência FS-IA' },
                        { nameBD: '3', descricao: 'ContingênciaDPEC' },
                        { nameBD: '4', descricao: 'Contingência FS-DA' },
                        { nameBD: '5', descricao: 'Contingência SVC-AN' },
                        { nameBD: '6', descricao: 'Contingência SVC-RS' },
                      ]}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={1} xl={1}>
                    <BasicSelect
                      name='tpnfe'
                      label='Tipo'
                      data={[
                        { nameBD: '0', descricao: 'Entrada' },
                        { nameBD: '1', descricao: 'Saida' },
                      ]}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='serie'
                      label='Serie'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='nfe'
                      label='Numero'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                    <AutoCompleteCfop
                      isExternalLoading={statuss === 1 ? isLoading : true}
                      cfops={cfop}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='finnfe'
                      label='Finalidade'
                      data={[
                        { nameBD: '1', descricao: 'NF-e normal' },
                        { nameBD: '2', descricao: 'NF-e complementar' },
                        { nameBD: '3', descricao: 'NF-e de ajuste' },
                        { nameBD: '4', descricao: 'Devolução de mercadoria' },
                      ]}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='indpag'
                      label='Pagamento'
                      data={[
                        { nameBD: '0', descricao: 'Vista' },
                        { nameBD: '1', descricao: 'Prazo' },
                      ]}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='tpag'
                      label='Tipo Pagamento'
                      data={[
                        { nameBD: '01', descricao: 'Dinheiro' },
                        { nameBD: '02', descricao: 'Cheque' },
                        { nameBD: '03', descricao: 'Cartao Credito' },
                        { nameBD: '04', descricao: 'Cartao Debito' },
                        { nameBD: '05', descricao: 'Credito Loja' },
                        { nameBD: '10', descricao: 'Vale Alimentacao' },
                        { nameBD: '11', descricao: 'Vale Refeicao' },
                        { nameBD: '12', descricao: 'Vale Presente' },
                        { nameBD: '13', descricao: 'Vale Combustivel' },
                        { nameBD: '15', descricao: 'Boleto Bancario' },
                        { nameBD: '16', descricao: 'Deposito Bancario' },
                        { nameBD: '17', descricao: 'Pagamento Instantaneo(PIX)' },
                        { nameBD: '18', descricao: 'TransfBancario' },
                        { nameBD: '19', descricao: 'Programa Fidelidade' },
                        { nameBD: '90', descricao: 'Sem Pagamento' },
                        { nameBD: '99', descricao: 'Outro' },
                      ]}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vbc'
                      label='Base C. ICMS'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vicms'
                      label='Valor ICMS'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vconfins'
                      label='COFINS'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vpis'
                      label='PIS'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vipi'
                      label='Valor IPI'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vfrete'
                      label='Valor Frete'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vseg'
                      label='Valor Seguro'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vdesc'
                      label='desconto'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2} md={2} lg={1} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vprod'
                      label='Valor dos Produtos'
                      disabled={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={1} >
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={5}>
                    <AutoCompleteTransportadora
                      isExternalLoading={statuss === 1 ? isLoading : true}
                      uuidtransportadora={handleuuidtransportadora}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
                    <AutoCompleteVeiculos
                      isExternalLoading={statuss === 1 ? isLoading : true}
                      idtransportadora={transportadora}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='modfrete'
                      label='Tipo Frete'
                      data={[
                        { nameBD: '0', descricao: 'Conta Emitente' },
                        { nameBD: '1', descricao: 'Conta Destinatario' },
                        { nameBD: '2', descricao: 'Conta Terceiros' },
                        { nameBD: '3', descricao: 'Proprio Remetente' },
                        { nameBD: '4', descricao: 'Proprio Destinatario' },
                        { nameBD: '9', descricao: 'Sem Frete' },
                      ]}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2} md={2} lg={3} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='vnfe'
                      label='Valor Nota'
                      disabled={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TableContainer component={Paper} variant="outlined" sx={{ width: 'auto', height: 350, maxHeight: 350 }}>
                  <Table size="small">
                    <TableHead sx={{ backgroundColor: '#03421eff' }}>
                      <TableRow >
                        <TableCell style={{width: 250, color: '#fff' }} align='left'>Descrição</TableCell>
                        <TableCell style={{ color: '#fff' }} align='center'>NCM</TableCell>
                        <TableCell style={{ color: '#fff' }} align='center'>CST</TableCell>
                        <TableCell style={{ color: '#fff' }} align='center'>CFOP</TableCell>
                        <TableCell style={{ color: '#fff' }}>UN</TableCell>
                        <TableCell style={{ color: '#fff' }} align='right'  >Quantidade</TableCell>
                        <TableCell style={{ color: '#fff' }} align='right'>Unitario</TableCell>
                        <TableCell style={{ color: '#fff' }} align='right'>Desconto</TableCell>
                        <TableCell style={{ color: '#fff' }} align='right'>Total</TableCell>
                        <TableCell style={{ color: '#fff' }} align='right'>B.C ICMS</TableCell>
                        <TableCell style={{ color: '#fff' }} align='right'>V. ICMS</TableCell>
                        <TableCell style={{ color: '#fff' }} align='right'>Aliq. ICMS</TableCell>
                        <TableCell style={{ color: '#fff' }} align='center'>
                          <IconButton color='inherit' disabled={statuss === 1 ? isLoading : true} aria-label="add to shopping cart" size="small">
                            <AddShoppingCartIcon onClick={() => { setIditens('novo'); setOpen(true); }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map(row => (
                        <TableRow key={row.iditens}
                          hover
                          sx={{ cursor: 'pointer' }}
                        >
                          <TableCell style={{width: 250 }} >{row.descricao}</TableCell>
                          <TableCell align='center'>{row.ncm}</TableCell>
                          <TableCell align='center'>{row.cst}</TableCell>
                          <TableCell align='center'>{row.cfop}</TableCell>
                          <TableCell>{row.un}</TableCell>
                          <TableCell align='right' >{row.quantidade.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
                          <TableCell align='right'>{row.preco.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          <TableCell align='right'>{row.desconto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          <TableCell align='right'>{row.total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          <TableCell align='right'>{row.bcicms.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          <TableCell align='right'>{row.valoricms.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          <TableCell align='right'>{row.percentual.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          <TableCell align='center'>
                            <IconButton size="small" onClick={() => { setIditens(row.iditens); handleBuscarDados(row.iditens); setOpen(true); }}>
                              <Icon >edit</Icon>
                            </IconButton>
                            <IconButton disabled={statuss === 1 ? isLoading : true} size="small" onClick={() => { handleDeleteItem(row.iditens); }}>
                              <Icon>delete</Icon>
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableFooter>
                      {isLoading && (
                        <TableRow>
                          <TableCell colSpan={12}>
                            <LinearProgress variant='indeterminate' />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableFooter>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={2} >
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <VTextField
                      fullWidth
                      name='obscomplementar'
                      label='Informaçoes Adicionais'
                      multiline
                      rows={4}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid container item direction="row" spacing={2} >
                      <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                        <VTextField
                          fullWidth
                          size='small'
                          name='volumequantidade'
                          label='Quantidade'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                        <VTextField
                          fullWidth
                          size='small'
                          name='volesp'
                          label='Espécie'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={2} xl={4}>
                        <VTextField
                          fullWidth
                          size='small'
                          name='volumemarca'
                          label='Marca'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                        <VTextField
                          fullWidth
                          size='small'
                          name='volumepesobruto'
                          label='Peso Bruto'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                        <VTextField
                          fullWidth
                          size='small'
                          name='volumepesoliquido'
                          label='Peso Liquido'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <VTextField
                          fullWidth
                          name='nferef'
                          label='Chave da Nota Referenciada'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <DialoNfe
              id={iditens}
              value={guuid}
              cfop={Number(cfop)}
              dados={dadositens}
              open={open}
              onDados={handleItens}
              onClose={handleClose}
              status={statuss}
            />
            <DialoCancelar
              id={id}
              open={opencancelar}
              onClose={handleClosecancelar}
              status={statuss}
            />
            <DialogCartaCorrecao
              id={id}
              open={opencarta}
              onClose={handleClosecarta}
              status={statuss}
            />
          </Grid>
        </Box>
      </VForm>

    </LayoutBaseDePaginaNfe>
  );
};